import { useState, useEffect } from "react";

const API_BASE = "https://studios.artistic-spaces.co.uk/api/public";

export function useAvailability() {
  const [buildings, setBuildings] = useState([]);
  const [studios, setStudios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchAvailability() {
      try {
        console.log("[useAvailability] Fetching:", `${API_BASE}/availability`);
        const res = await fetch(`${API_BASE}/availability`);
        console.log("[useAvailability] Status:", res.status);
        if (!res.ok) throw new Error(`HTTP ${res.status} — ${res.statusText}`);
        const data = await res.json();
        console.log("[useAvailability] Response:", data);
        setBuildings(data.buildings || []);
        setStudios(data.studios || []);
      } catch (err) {
        console.error("[useAvailability] Error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchAvailability();
  }, []);

  function getStudiosByBuildingSlug(slug) {
    return studios.filter((s) => s.building_slug === slug);
  }

  function getBuildingWithStudios() {
    return buildings
      .map((b) => ({
        ...b,
        studios: getStudiosByBuildingSlug(b.slug),
      }))
      .filter((b) => b.studios.length > 0);
  }

  return {
    buildings,
    studios,
    loading,
    error,
    getStudiosByBuildingSlug,
    getBuildingWithStudios,
  };
}